// ClientDetailsPage.jsx

// Dependencies
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import ClientDetails from '@/components/data/clients/ClientDetails';

// Services
import { getClient, getClientEngagements } from '@/services/schedulingService';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const ClientDetailsPage = () => {
  const { clientCode } = useParams();
  const { t } = useTranslation();

  const [client, setClient] = useState(null);
  const [engagements, setEngagements] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        // Get client details
        const client = await getClient(clientCode);
        setClient(client);
        
        // Get engagements for this client
        const engagements = await getClientEngagements(clientCode);
        setEngagements(engagements);
      } catch (error) {
        console.error('Error fetching client data:', error);
        setClient(
          {
            ClientID: '1',
            ClientCode: 'BBC',
            Client: 'British Broadcasting Corporation',
            Alias: 'British'
          }
        );
        setEngagements(
          [
            {
              EngagementID: '201',
              EngagementName: 'BBC - Documentary',
              EngagementAlias: 'BBC',
              Type: 'External',
              Status: 'Online',
              Manager: 'John Doe'
            },
            {
              EngagementID: '202',
              EngagementName: 'BBC - News',
              EngagementAlias: 'BBC-News',
              Type: 'External',
              Status: 'Online',
              Manager: 'Jane Smith'
            }
          ]
        );
      }
    }
    fetchData();
  }, [clientCode]);

  return (
    <div className={homeCss.container}>
      <div className={homeCss.mainContent}>
        <p className={homeCss.description}>{t('CLIENTS_TABLE.TITLE')}</p>
        {client && engagements && (
          <ClientDetails 
            client={client} 
            engagements={engagements}
          />
        )}
      </div>
    </div>
  );
};

export default ClientDetailsPage;
